(() => {
  const config = window.__preaIndexEffectsConfig || {};

  window.__preaLoadScript(config.scrollRevealJs, 'prea-scroll-reveal-js');

  if (!config.isIndex && !config.isProduct) return;

  const selectors = [
    '[data-prea-best-sellers-section]',
    '[data-prea-new-arrivals-section]',
    '[data-prea-testimonials-section]',
    '[data-prea-theme-section]',
    '[data-sbm-section]'
  ];
  let loaded = false;

  const loadSliders = () => {
    if (loaded) return;
    loaded = true;

    window.__preaLoadScript(config.homeSlidersJs, 'prea-home-sliders').catch(() => {
      loaded = false;
    });
  };

  const hasSlider = () => selectors.some((selector) => document.querySelector(selector));

  let onTargetIntent = null;
  let onScrollIntent = null;
  let loadQueued = false;
  let prefetched = false;
  const sliderLoaderStartedAt = window.performance ? window.performance.now() : Date.now();

  const prefetchScript = (src, id) => {
    if (!src || document.getElementById(id) || document.querySelector('link[href="' + src + '"]')) return;

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'script';
    link.href = src;
    link.id = id;
    document.head.appendChild(link);
  };

  const prefetchSliders = () => {
    if (prefetched || loaded || !hasSlider()) return;
    prefetched = true;
    prefetchScript(config.homeSlidersJs, 'prea-home-sliders-prefetch');
  };

  const cleanupIntentListeners = () => {
    if (onScrollIntent) window.removeEventListener('scroll', onScrollIntent);
    if (onTargetIntent) {
      document.removeEventListener('pointerover', onTargetIntent, true);
      document.removeEventListener('pointerdown', onTargetIntent, true);
      document.removeEventListener('focusin', onTargetIntent, true);
    }
    document.removeEventListener('keydown', onIntent, true);
  };

  const scheduleSliderLoad = (priority = 'normal') => {
    if (loaded || loadQueued) return;
    loadQueued = true;

    const run = () => {
      loadQueued = false;
      loadSliders();
      cleanupIntentListeners();
    };

    const age = (window.performance ? window.performance.now() : Date.now()) - sliderLoaderStartedAt;
    if (priority === 'fast' || age > 1800) {
      window.setTimeout(run, 0);
    } else if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 450 });
    } else {
      window.setTimeout(run, 260);
    }
  };

  function onIntent() {
    if (!hasSlider()) return;
    loadSliders();
    cleanupIntentListeners();
  }

  const isSliderIntent = (event) =>
    event.target &&
    event.target.closest &&
    selectors.some((selector) => event.target.closest(selector));

  onTargetIntent = (event) => {
    if (!isSliderIntent(event)) return;
    onIntent();
  };

  onScrollIntent = () => {
    if (window.scrollY < 48) return;
    prefetchSliders();
    scheduleSliderLoad('fast');
  };

  window.addEventListener('scroll', onScrollIntent, { passive: true });
  document.addEventListener('pointerover', onTargetIntent, { capture: true, passive: true });
  document.addEventListener('pointerdown', onTargetIntent, { capture: true, passive: true });
  document.addEventListener('focusin', onTargetIntent, { capture: true });
  document.addEventListener('keydown', onIntent, { capture: true });

  const prefetchSlidersOnIdle = () => {
    const warm = () => prefetchSliders();

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warm, { timeout: 1000 });
    } else {
      window.setTimeout(warm, 900);
    }
  };

  const observeNearSliders = () => {
    if (!('IntersectionObserver' in window)) return;

    const targets = selectors.flatMap((selector) => Array.from(document.querySelectorAll(selector)));
    if (!targets.length) return;

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      prefetchSliders();
      scheduleSliderLoad();
    }, { rootMargin: '900px 0px' });

    targets.forEach((target) => observer.observe(target));
  };

  if (document.readyState === 'complete') {
    prefetchSlidersOnIdle();
    observeNearSliders();
  } else {
    window.addEventListener('load', prefetchSlidersOnIdle, { once: true });
    document.addEventListener('DOMContentLoaded', observeNearSliders, { once: true });
  }
})();

